import groups from './components/groups'
import students from './components/students'
import student from './components/student'


const views = { groups, students, student}

export {views as default}
